/* eslint   */

import { useSelector } from 'react-redux';
import { isNumber } from 'lodash';

import { COUNTRIES, TRIMS_PARAMETERS } from '@constants';

export const formatNumber = num =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

export const getCountryCurrency = country => COUNTRIES?.[country]?.currency;

export const formatPrice = (symbol, price = null, iso) => {
  if (!price) {
    return null;
  }

  const currencyISO = iso ? ` ${iso.toUpperCase()}` : '';
  const currencySymbol = symbol || '';
  const formattedNumber = formatNumber(price);

  return `${currencySymbol}${formattedNumber}${currencyISO}`;
};

export const getTrimPricing = (trim, country, deposit) => {
  const trimParameter = TRIMS_PARAMETERS[trim];
  const countryCurrency = getCountryCurrency(country);
  const currencyISO = countryCurrency?.iso;
  const currencySymbol = countryCurrency?.symbol;
  const reservationPrice = countryCurrency?.values?.[trimParameter] || null;
  const depositDifference = reservationPrice - deposit;
  const upgradePrice = depositDifference <= 0 ? null : depositDifference;
  const totalPrice = countryCurrency?.total?.[trimParameter] || null;

  return {
    formattedReservationPrice: formatPrice(
      currencySymbol,
      reservationPrice,
      currencyISO
    ),
    reservationPrice: reservationPrice,
    formattedUpgradePrice: formatPrice(
      currencySymbol,
      upgradePrice,
      currencyISO
    ),
    upgradePrice: upgradePrice,
    formattedTotalPrice: formatPrice(currencySymbol, totalPrice, currencyISO),
    totalPrice: totalPrice,
  };
};

export const formatPriceWithCents = (amount, currency) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  if (currency === 'CAD') {
    let formattedAmount = amount
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (language === 'fr-ca') {
      formattedAmount = `${formattedAmount} CAD`;
    } else {
      formattedAmount = `CAD$${formattedAmount}`;
    }
    return formattedAmount;
  }
  return amount?.toLocaleString('en-US', {
    style: 'currency',
    currency,
  });
};

export const amountToCurrencyString = (amountWithCents, currency, language) => {
  if (!isNumber(amountWithCents)) return '';
  if (currency === 'CAD') {
    amountWithCents = (amountWithCents / 100)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (language === 'fr-ca') {
      amountWithCents = `${amountWithCents} CAD`;
    } else {
      amountWithCents = `CAD$${amountWithCents}`;
    }
  } else {
    amountWithCents = (amountWithCents / 100).toLocaleString('en-us', {
      style: 'currency',
      currency,
    });
  }
  return amountWithCents;
};

export const formatAmountToCurrencyString = (amount, currency, language) => {
  if (!isNumber(amount)) return '';

  // Check if the amount has a decimal part (i.e., check for remainder when divided by 1)
  const hasDecimal = amount % 1 !== 0;

  // Use toLocaleString for proper currency formatting
  let formattedAmount = amount.toLocaleString(language.split('-')[0], {
    style: 'currency',
    currency,
    minimumFractionDigits: hasDecimal ? 2 : 0, // Show 2 decimals if there is a decimal part, else show none
    maximumFractionDigits: hasDecimal ? 2 : 0, // Same here
  });

  return formattedAmount;
};
